interface BannerProps {
  message: string;
  onDismiss: () => void;
  onAction?: () => void;
  actionLabel?: string;
  variant?: 'info' | 'warning';
}

export function Banner({
  message,
  onDismiss,
  onAction,
  actionLabel,
  variant = 'info',
}: BannerProps) {
  const bg =
    variant === 'warning'
      ? 'bg-cream border-grain-gold'
      : 'bg-cream border-card-border';
  return (
    <div
      role="alert"
      class={`border-b px-4 py-2.5 flex items-center justify-between gap-3 ${bg}`}
    >
      <span class="text-sm text-body flex-1">{message}</span>
      <div class="flex items-center gap-2 shrink-0">
        {onAction && actionLabel && (
          <button
            type="button"
            onClick={onAction}
            class="text-sm font-medium text-hudson-navy underline focus:outline-none focus:ring-2 focus:ring-hudson-navy rounded"
          >
            {actionLabel}
          </button>
        )}
        <button
          type="button"
          onClick={onDismiss}
          aria-label="Dismiss banner"
          class="text-body/70 hover:text-body focus:outline-none focus:ring-2 focus:ring-hudson-navy rounded text-sm"
        >
          Got it
        </button>
      </div>
    </div>
  );
}
